export type ColumnClass = 'numeric' | 'categorical' | 'date';

export function classifyColumns( columns: string[], rows: Record<string, unknown>[] ): Map<string, ColumnClass> {
  const sample = rows.slice( 0, 50 );
  const result = new Map<string, ColumnClass>();

  for ( const col of columns ) {
    const values = sample.map( r => r[col] ).filter( v => v !== null && v !== undefined );
    if ( values.length === 0 ) {
      result.set( col, 'categorical' );
      continue;
    }

    // Booleans should be categorical, not numeric (even though Number(true)=1)
    const allBoolean = values.every( v => typeof v === 'boolean' || v === 'true' || v === 'false' );
    if ( allBoolean ) {
      result.set( col, 'categorical' );
      continue;
    }

    const allNumeric = values.every( v => {
      if ( typeof v === 'boolean' ) return false;
      const n = Number( v );
      return Number.isFinite( n );
    } );
    if ( allNumeric ) {
      result.set( col, 'numeric' );
      continue;
    }

    const allDate = values.every( v => typeof v === 'string' && /[-/T]/.test( v ) && !isNaN( Date.parse( v ) ) );
    if ( allDate ) {
      result.set( col, 'date' );
      continue;
    }

    result.set( col, 'categorical' );
  }

  return result;
}
